import { Skeleton } from "@mui/material";
import React from "react";
import { NumericFormat } from "react-number-format";
import { currency, thousandsdisplay } from "../../../Common/Credentials";

const RenderPurchaseData = ({ activeChart, orders, invoice, loader }) => {
  const items = activeChart === "Orders" ? orders : invoice;

  return (
    <div className="banner-stats-row">
      {items.map((item, key) => (
        <div className="banner-stat-item" key={key}>
          <div className="banner-stat-label">{item.name}</div>
          {loader ? (
            <Skeleton
              variant="rounded"
              width={120}
              height={24}
              sx={{ margin: "0 auto", bgcolor: "rgba(255,255,255,0.2)" }}
            />
          ) : (
            <div className="banner-stat-value">
              <span style={{ fontSize: "0.75rem", fontWeight: 500 }}>{currency} </span>
              <NumericFormat
                displayType={"text"}
                value={item.amount}
                decimalScale={2}
                fixedDecimalScale={true}
                disabled={true}
                thousandSeparator={true}
                thousandsGroupStyle={thousandsdisplay}
              />
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

export default RenderPurchaseData;
